import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { Objects } from "@nexu-library/utilities";

@Injectable()
export class StripUndefinedParamsInterceptor implements HttpInterceptor {
  constructor() {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = Objects.stripUndefinedParams(request.params);
    request = request.clone({ params });
    return next.handle(request);
  }
}
